import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import security from "../../../services/security.js";
import auth from "../../../services/auth.js";
import events from "../../../services/events.js";
import companies from "../../../services/companies.js";
import orders from "../../../services/orders.js";

class OrdersmasterlistController {
  constructor(
    $http,
    $localStorage,
    $state,
    $stateParams,
    AuthService,
    OrdersService,
    EventsService,
    CompaniesService,
    SecurityService,
    $rootScope,
    CommonService,
    EnvService,
    $timeout,
    $base64
  ) {
    this.name = "ordersmasterlist";
    $localStorage.activeStateName = "ordersmasterlist";

    if (!AuthService.isLoggedIn()) {
      $state.go("signin");
      return;
    }

    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$companies = CompaniesService;
    this.$events = EventsService;
    this.$stateParams = $stateParams;
    this.$security = SecurityService;
    this.$orders = OrdersService;
    this.$rootScope = $rootScope;
    this.currentPageNumber = 1;
    this.$base64 = $base64;
    this.$common = CommonService;
    this.$env = EnvService;
    this.$timeout = $timeout;
    this.remain_loading_count = 0;
    this.currentUser = this.$auth.getUserData();
    this.data = {};
    var _this = this;

    console.log("what are the env variables");
    console.dir(this.$env);
    console.dir(this.$base64);
    _this.encodeBasicAuthData();
  }

  encodeBasicAuthData() {
    var _this = this;
    let user = _this.$env.EnvironmentConfig.ezcaterKey.username;
    let password = _this.$env.EnvironmentConfig.ezcaterKey.password;
    let auth = user + ":" + password;
    let encode = _this.$base64.encode(auth);
    this.data.auth = encode;
    _this.getOrders();
  }

  getOrders() {
    var _this = this;
    let data = this.data;
    /*
		_this.$http.get('https://delivery.ezcater.com/api/partner/v1/actionable_deliveries', {
			headers: { 'Content-Type': undefined, 'Authorization': 'Basic ' + data.auth }
		}).then(function(response){
			console.log("response");
			console.dir(response);
		}, function(error){
			console.log("error");
			console.dir(error);
		});
		*/

    _this.$orders.getOrders(data).then(
      function (response) {
        console.log("response");
        console.dir(response);
      },
      function (error) {
        console.log("in error");
        console.dir(error);
      }
    );
  }
}

OrdersmasterlistController.$inject = [
  "$http",
  "$localStorage",
  "$state",
  "$stateParams",
  "auth",
  "orders",
  "events",
  "companies",
  "security",
  "$rootScope",
  "common",
  "env",
  "$timeout",
  "$base64",
];

export default OrdersmasterlistController;



// WEBPACK FOOTER //
// ./client/app/components/orders/ordersmasterlist/ordersmasterlist.controller.js